import Marquee from "react-fast-marquee";

export const EditorialMarquee = ({ dark = false, items, className = "" }) => {
  const words = items || [
    "Locka — Where Every Step is Couture",
    "Step Into Timeless Style",
    "Crafted With Heritage",
    "Worn With Flair",
  ];
  return (
    <div
      className={`overflow-hidden border-y py-5 ${
        dark ? "border-gold/40 bg-gold text-[#0B101E]" : "border-navy/10 bg-cream text-navy"
      } ${className}`}
      data-testid="editorial-marquee"
    >
      <Marquee speed={28} gradient={false} pauseOnHover>
        {words.concat(words).map((w, i) => (
          <span key={i} className="mx-8 flex items-center gap-16 whitespace-nowrap font-serif text-lg italic tracking-wide md:text-xl">
            {w}
            <span className={`not-italic ${dark ? "text-burgundy" : "text-gold"}`} aria-hidden="true">✦</span>
          </span>
        ))}
      </Marquee>
    </div>
  );
};
